import type { Special } from "@/types";

export const specials: Special[] = [
  {
    id: "s01",
    name: "悬疑烧脑夜",
    cover:
      "https://readdy.ai/api/search-image?query=a%20dark%20moody%20investigation%20room%20with%20scattered%20case%20files%20an%20old%20typewriter%20and%20a%20single%20dim%20lamp%2C%20cinematic%20wide%20film%20still%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=1200&height=700&seq=special-s01&orientation=landscape",
    intro: "把逻辑交给剧情，把冷汗交给夜晚。一期足够烧脑的悬疑片单。",
    description:
      "悬疑最迷人的地方，从来不是反转本身，而是反转背后那些被藏起来的人性。这个专题收录了氛围扎实、逻辑自洽的作品，适合在深夜一次看到底。建议关灯观看，并准备好随时倒回去复盘细节。",
    tag: "类型专题",
    recommend: "如果你喜欢用脑子看电影，这里就是你的主场。",
    titleIds: ["t01", "t05", "t08", "t10"],
    relatedIds: ["s03", "s04"],
  },
  {
    id: "s02",
    name: "冬日治愈片单",
    cover:
      "https://readdy.ai/api/search-image?query=a%20cozy%20winter%20reading%20nook%20by%20a%20frosted%20window%20with%20a%20warm%20blanket%20a%20mug%20and%20soft%20fairy%20lights%2C%20cinematic%20wide%20film%20still%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=1200&height=700&seq=special-s02&orientation=landscape",
    intro: "天气越冷，越需要一些温柔的故事把心捂热。",
    description:
      "有些作品不急着讲道理，只是安静地陪着你度过一段时光。这份冬日片单里的故事节奏舒缓、情感真挚，适合泡一杯热饮，在窗边慢慢看完。它们不会给你答案，但会让你觉得被理解。",
    tag: "情绪专题",
    recommend: "适合疲惫的夜晚，也适合需要一点温柔的你。",
    titleIds: ["t06", "t14", "t02"],
    relatedIds: ["s01", "s03"],
  },
  {
    id: "s03",
    name: "华语科幻新浪潮",
    cover:
      "https://readdy.ai/api/search-image?query=a%20futuristic%20city%20skyline%20with%20glowing%20holograms%20and%20flying%20vehicles%20at%20dusk%2C%20cinematic%20wide%20film%20still%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=1200&height=700&seq=special-s03&orientation=landscape",
    intro: "当想象力追上技术，华语科幻正在讲属于自己的故事。",
    description:
      "从量子设定到东方奇幻，再到遥远的星际拓荒，这些作品不再只是模仿，而是尝试用本土的视角去讨论科技与人。专题收录了近年制作水准与口碑俱佳的科幻作品，带你看清这个类型正在生长出的新形状。",
    tag: "类型专题",
    recommend: "给所有仰望星空的人，一份可以立刻开看的清单。",
    titleIds: ["t08", "t03", "t04", "t13"],
    relatedIds: ["s01", "s02"],
  },
  {
    id: "s04",
    name: "高分权谋剧精选",
    cover:
      "https://readdy.ai/api/search-image?query=an%20ancient%20chinese%20bronze%20seal%20and%20a%20scroll%20on%20a%20wooden%20table%20with%20candlelight%2C%20cinematic%20wide%20film%20still%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=1200&height=700&seq=special-s04&orientation=landscape",
    intro: "一句话里三个意思，一个眼神就是一场博弈。",
    description:
      "权谋剧的魅力在于“看懂了才过瘾”。这个专题挑选了台词扎实、群像丰满、伏笔回收干净的高分作品。它们把朝堂与江湖都拍成了棋盘，每一个选择都可能改写结局。适合喜欢慢慢品、反复刷的观众。",
    tag: "类型专题",
    recommend: "如果你享受层层解谜的快感，这一单不会让你失望。",
    titleIds: ["t09", "t10"],
    relatedIds: ["s03", "s01"],
  },
];